
import { ElButton, ElButtonGroup, ElIcon, ElSpace } from "element-plus";
import { defineComponent } from "vue";
import { Grid as VxeGrid, Pager as VxePager } from "vxe-table";
import { IceCreamRound } from "@element-plus/icons";
export default defineComponent({
	props: {
		diallel: {
			type: Boolean,
			default: false,
		},
	},
	setup(props: any, { slots }: any) {
		const columns: any = [
			{ type: "seq", width: 60 },
			{ type: "checkbox", width: 100 },
			{ field: "name", title: "名字" },
			{ field: "age", title: "年龄" },
			{ field: "role", title: "Role" },
			{ field: "address", title: "Address" },
		];
		const toolbarConfig: any = {
			zoom: true,
			custom: true,
			slots: {
				// 自定义插槽模板
				buttons: "toolbar_buttons",
			},
		};

		return () => {
			return (
				<VxeGrid border toolbarConfig={toolbarConfig} columns={columns}>
					{{
						toolbar_buttons: () => {
							return (
								<ElSpace wrap>
									<ElButton type="primary" icon="el-close-bold">
										<ElIcon style="vertical-align: middle;">
											<IceCreamRound />
										</ElIcon>
										<span style="vertical-align: middle;"> 搜索 </span>
									</ElButton>
									<ElButton type="primary">申请退回</ElButton>
								</ElSpace>
							);
						},

						pager: () => {
							return <VxePager></VxePager>;
						},
					}}
				</VxeGrid>
			);
		};
	},
});
